export enum EShoppingStorageKeys {
  ShoppingSessionId = 'shoppingSessionId',
}
